export const formErrorMessages = {
  required: 'Required',
  validToGreaterThanValidFrom: 'Valid To should be greater than Valid From',
  minCompanies: 'At least one company should be selected',
};
